import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-z', 'LetterZ', [["path",{"d":"M7 4h10l-10 16h10","key":"svg-0"}]]);